export default __webpack_public_path__ + "static/media/wallholebig.96edaabf.png";